/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { createAction } from '../../../utils/redux-utils';

export enum RegInspectorDashBoardActionType {
    OPEN_REG_INSPECTOR_DASHBOARD = 'RegInspector dashboard/ open regional inspector dashboard',
}

export const openRegInspectorDashBoard = () =>
    createAction(RegInspectorDashBoardActionType.OPEN_REG_INSPECTOR_DASHBOARD);
